import React, { useState, useEffect } from 'react';

const SuperAdminNav = ({ setSidebarOpen, userInfo, pageTitle, icon }) => {
    const [greeting, setGreeting] = useState('');

    useEffect(() => {
        const hour = new Date().getHours();
        if (hour < 12) setGreeting('Good Morning');
        else if (hour < 18) setGreeting('Good Afternoon');
        else setGreeting('Good Evening');
    }, []);

    const userInitial = userInfo ? (userInfo.fullName || userInfo.full_name || userInfo.name || 'A').charAt(0).toUpperCase() : 'A';
    const userName = userInfo ? (userInfo.fullName || userInfo.full_name || userInfo.name || 'Admin') : 'Admin';
    // Use first name for greeting
    const firstName = userName.split(' ')[0];

    return (
        <div className="top-header">
            <div className="header-left">
                <button onClick={() => setSidebarOpen(true)} className="menu-toggle">☰</button>
                <div className="header-title-section">
                    {pageTitle ? (
                        // If pageTitle is provided, show it
                        <div className="header-name" style={{ fontSize: '24px' }}>{icon} {pageTitle}</div>
                    ) : (
                        // Default greeting logic for Dashboard
                        <>
                            <div className="header-greeting">{greeting},</div>
                            <div className="header-name">{firstName}</div>
                        </>
                    )}
                </div>
            </div>

            <div className="header-right">
                {/* Can add notifications bell here later */}
                <div className="user-avatar-header">{userInitial}</div>
            </div>
        </div>
    );
};

export default SuperAdminNav;
